import styles from "./GeneratePriceUpdateSheet.module.scss";
import Dropdown from "../../../../../../common/components/dropdown/Dropdown";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { updateIsLoading } from "../../../../../../reducerSlices/loaderSlice";
import { useDispatch } from "react-redux";
import { useAxios } from "../../../../../../services/useAxios";
import {
  APIMethods,
  urlConstants,
} from "../../../../../../common/constants/urlConstants";
import Button from "../../../../../../common/components/button/Button";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import PaginationComponent from "../../../../../../common/components/pagination/Pagination";
import { constants } from "../../../../../../common/constants/constants";
import { ToastNotification } from "../../../../../../common/components/toastNotification/ToastNotification";
import errorToast from "../../../../../../assets/images/errorToast.svg";
import successToast from "../../../../../../assets/images/successToast.svg";
import InputField from "../../../../../../common/components/formFields/inputField/inputField";

const columns: GridColDef[] = [
  {
    field: "id",
    headerName: "Product variant ID",
    width: 150,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "product_title",
    headerName: "Product variant title",
    flex: 1,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "supplier_product_code",
    headerName: "Supplier product code",
    width: 160,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "ordering_label",
    headerName: "Ordering label",
    width: 160,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "is_deactivated",
    headerName: "Deactivated",
    width: 100,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "is_instock",
    headerName: "In Stock",
    width: 100,
    sortable: false,
    disableColumnMenu: true,
  },
  {
    field: "product_option_unit_price",
    headerName: "Price",
    sortable: false,
    disableColumnMenu: true,
  },
];

function GeneratePriceUpdateSheet() {
  const [supplierList, setSupplierList] = useState<any>([]);
  const [selectedSupplier, setSelectedSupplier] = useState<string>("");
  const [productsData, setProductsData] = useState<any>([]);
  const [productCount, setProductCount] = useState<number>(0);
  const [loading, setLoading] = useState<any>(false);
  const dispatch = useDispatch();

  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(0);
  const visibleProducts = productsData;
  const [toastData, setToastData] = useState(constants.defaultToastData);

  const getSupplierDetails = useAxios({
    axiosParams: {
      url: `store/supplier?page=0`,
    },
    method: APIMethods.get,
  });

  const getUrl = (
    supplier_id: { id: string },
    offset: number,
    limit: number,
    isDownload?: boolean,
  ) => {
    return `admin/product/gen_price_update_sheet?offset=${offset}&limit=${limit}${`&supplier_id=${supplier_id.id}`}${
      isDownload ? `&download=true` : ""
    }&all_records=${isDownload ? "true" : "false"}`;
  };

  const schema = yup.object().shape({
    supplierName: yup
      .object({
        id: yup.string().required("Supplier Name is required"),
      })
      .required(),
  });
  const {
    watch,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  const getProducts = useAxios({
    axiosParams: {
      url: "",
    },
    method: APIMethods.get,
  });

  const getproductsList = async (offset: number, limit: number) => {
    setLoading(true);
    try {
      const response: any = await getProducts.fetchData({
        axiosParams: {
          url: getUrl(watch("supplierName"), offset, limit),
        },
      });
      if (response && response.data) {
        setProductsData(
          response.data?.product_data.map((item: any) => ({
            ...item,
            is_deactivated: item.is_deactivated ? "Yes" : "No",
            is_instock: item.is_instock ? "Yes" : "No",
          })),
        );
        setProductCount(response.data?.count);
      } else {
        setProductsData([]);
        setToastData({
          message: "Unable to fetch the products",
          status: "Fail",
        });
        setTimeout(() => {
          setToastData(constants.defaultToastData);
        }, 3000);
      }
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    // getproductsList();
  }, []);

  const handlePagination = (e: any, page: number) => {
    setCurrentPage(page - 1);
    getproductsList((page - 1) * itemsPerPage, itemsPerPage);
  };

  const getSupplierList = async () => {
    dispatch(updateIsLoading(true));

    const response: any = await getSupplierDetails.fetchData();
    dispatch(updateIsLoading(false));
    if (response && response?.status === "SUCCESS") {
      const businessData = response?.data;
      if (businessData && businessData?.length > 0) {
        const updatedBusiness = businessData?.map((element: any) => {
          return {
            ...element,
            id: element?.id,
            label: element?.business_name,
            value: element?.business_name,
            name: element?.business_name,
            outlets: element?.business_stores,
          };
        });
        if (updatedBusiness?.length > 0) {
          setSupplierList(updatedBusiness);
        }
      }
    }
  };

  useEffect(() => {
    getSupplierList();
  }, []);

  const onChangeField = (name: any) => (text: any) => {
    if (name === "supplierName") {
      setSelectedSupplier(text.name);
    }
  };
  const handleDownload = async () => {
    window.location.href = `${urlConstants.BASE_URL}${getUrl(
      watch("supplierName"),
      0,
      0,
      true,
    )}`;
  };
  const formSubmit = () => {
    setCurrentPage(0);
    setProductCount(0);
    setProductsData([]);
    getproductsList(0, itemsPerPage);
  };
  return (
    <>
      <div className={styles.reportContainer}>
        <section className={styles.tableFilterContainer}>
          <form onSubmit={handleSubmit(formSubmit)}>
            <div className={styles.filteSection}>
              <div className={styles.input}>
                <div className={styles.label}>Supplier Name</div>
                <Dropdown
                  minWidth="100%"
                  label={""}
                  selectedValue={selectedSupplier}
                  options={supplierList}
                  defaultLabel={"Select Supplier"}
                  id="supplier"
                  onChange={(selectedOption: any) => {
                    if (typeof selectedOption === "string") {
                      // setValue("supplierName", selectedOption);
                    } else {
                      setValue("supplierName", selectedOption);
                    }
                    onChangeField("supplierName")(selectedOption);
                  }}
                  tabIndex={3}
                  searchField={true}
                  itemStyles={{ maxWidth: 300 }}
                  ableToSelectSameValueFromDropdown={true}
                />
              </div>

              <div className={styles.input}>
                <div className={styles.label}>Selected Supplier</div>
                <InputField
                  value={selectedSupplier}
                  placeholder="Selected Supplier"
                  id="selectedSupplier"
                  maxWidth="100%"
                  tabIndex={4}
                  disabled
                />
                {errors.supplierName && (
                  <div className={styles.errorMessage}>
                    {errors.supplierName.id?.message}
                  </div>
                )}
              </div>

              <div className={styles.buttonSection}>
                <div>
                  <Button
                    type="submit"
                    handleClick={() => {}}
                    label="Generate"
                    width="160px"
                  />
                </div>
                <div>
                  <Button
                    label="Download"
                    type="button"
                    handleClick={handleDownload}
                    width="160px"
                    customClass={styles.submit}
                    disabled={productsData && productsData?.length === 0}
                  />
                </div>
              </div>
            </div>
          </form>
        </section>
        <section className={styles.tableContainer}>
          <DataGrid
            rows={visibleProducts}
            columns={columns}
            hideFooterPagination
            hideFooter
            getRowId={(row) => row.id}
            loading={loading}
            sx={{
              "& .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              ".MuiDataGrid-main": {
                backgroundColor: "#fff",
              },
            }}
          />
          <div className={styles.paginationContainer}>
            <PaginationComponent
              count={Math.ceil(productCount / itemsPerPage)}
              page={currentPage + 1}
              handlePagination={handlePagination}
            />
          </div>
        </section>
      </div>
      {toastData?.message && (
        <ToastNotification
          icon={toastData.status == "Success" ? successToast : errorToast}
          content={toastData?.message}
          position={"top-right"}
          autoClose={2000}
        />
      )}
    </>
  );
}

export default GeneratePriceUpdateSheet;
